import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function UploadCenterArrow({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M20 8.50001H16.5C15.39 8.50001 14.5 7.60001 14.5 6.50001V3.00001M9.74998 14.25L12 12L14.25 14.25M11.99 17V12M19.12 6.12001L16.87 3.87001C16.3 3.30001 15.54 2.98901 14.74 2.98901H6.97998C5.31998 2.98901 3.97998 4.32901 3.97998 5.98901V17.989C3.97998 19.639 5.31998 20.989 6.97998 20.989H16.98C18.63 20.989 19.98 19.639 19.98 17.989V8.22001C19.97 7.42001 19.66 6.66001 19.1 6.09001L19.12 6.12001Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default UploadCenterArrow;